import { gql } from '@edreamsodigeo/frontend-api-client';

const LOCATION_FRAGMENT = gql`
  fragment Location on Location {
    id
    iata
    name
    cityName
    countryName
    locationType
  }
`;

export const SHOPPING_SUMMARY_ITINERARY = gql`
  ${LOCATION_FRAGMENT}
  query GetShoppingSummaryItinerary($request: ShoppingSummaryRequest!) {
    getShoppingSummary(request: $request) {
      products {
        ... on ItineraryProduct {
          productInfo {
            transportTypes
            legs {
              segments {
                id
                duration
                transportTypes
                baggageCondition
                sections {
                  id
                  isHub
                  departureDate
                  arrivalDate
                  flightCode
                  departureTerminal
                  arrivalTerminal
                  duration
                  vehicleModel
                  transportType
                  cabinClass
                  technicalStops {
                    location {
                      ...Location
                    }
                    arrivalDate
                    departureDate
                  }
                  carrier {
                    id
                    name
                  }
                  operatingCarrier {
                    id
                    name
                  }
                  commercialBrand {
                    id
                    name
                  }
                  departure {
                    ...Location
                  }
                  destination {
                    ...Location
                  }
                }
              }
            }
          }
        }
      }
      totalNumPassengers
    }
  }
`;
